import { render, staticRenderFns } from "./AppHeading.vue?vue&type=template&id=6e9238e4&scoped=true&"
import script from "./AppHeading.vue?vue&type=script&lang=js&"
export * from "./AppHeading.vue?vue&type=script&lang=js&"
import style0 from "./AppHeading.vue?vue&type=style&index=0&id=6e9238e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9238e4",
  null
  
)

export default component.exports